export function getSpamData() {

    /* eslint-disable */
    let data = {
        emails : [
            // rossi and novak spam mails
            {
                id: 100,
                from: {
                    email: 'schnaeppchen@schoko-laden.net',
                    name: 'Schoko-Laden.net',
                    avatar: require('@src/assets/images/portrait/chocolate.jpeg').default
                },
                to: [{
                    name: 'Marc Novak',
                    email: 'marc.novak@pronto-posto.com'
                }, {
                    name: 'Francesca Rossi',
                    email: 'francesca.amore@pronto-posto.com'
                },
                ],
                subject: 'Schokoschnäppchen Häppchen für dich!',
                cc: [],
                bcc: [],
                message: '<p>+++Nur noch 6 Monate bis Weihnachten!+++</p> <p>Deck dich jetzt mit unseren einzigarten Fabrikverkaufsproben ein!<p> </p><p>Frisch von Fließband direkt auf deine Zunge! Mit dem Code "Sommerloch10" bekommst du 10% Rabatt auf alle Produkte!</p> <p>Worauf wartest du noch?</p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Do. Jun. 03 2022 02:10:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: false
            },
            {
                id: 101,
                from: {
                    email: 'support@crime-cases.de',
                    name: 'Crime Cases',
                    avatar: require('@src/assets/images/portrait/CrimeCases.png').default
                },
                to: [{
                    name: 'Marc Novak',
                    email: 'marc.novak@pronto-posto.com'
                }, {
                    name: 'Francesca Rossi',
                    email: 'francesca.amore@pronto-posto.com'
                },
                {
                    name: 'Maximilian Lange',
                    email: 'm.lange@pronto-posto.com'
                },
                ],
                subject: 'Dein neuer Job?',
                cc: [],
                bcc: [],
                message: '<p>Du bist ein Fan von Rätseln und Detektiv Spielen? 🕵🏼‍♂️</p> <p>Du hast Erfahrung in Story Writing ✍️, Design 🧑‍🎨, Projektmanagement 🗓️ und/oder Web Development 🧑‍💻?<p> <p>Dann melde dich bei uns, wir freuen uns dich kennenzulernen!</p> <p>Überrasche uns mit einer kreativen Bewerbung, die du an <a href = "mailto: support@crime-cases.de">support@crime-cases.de</a> sendest!</p>',
                attachments: [],
                isStarred: false,
                labels: ['company'],
                time: 'Do. Jan. 11 2022 10:10:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: false
            },
            // rossi spam mails
            {
                id: 102,
                from: {
                    email: 'shipping@spiele-versand-24.com',
                    name: 'Spiele Versand',
                    avatar: require('@src/assets/images/portrait/board-games.png').default
                },
                to: [{
                        name: 'Francesca Rossi',
                        email: 'francesca.amore@pronto-posto.com'
                    },
                ],
                subject: 'Ihre Bestellung wurde versendet',
                cc: [],
                bcc: [],
                message: '<h2>Versandbestätigung </h2><br><p>Ihre Bestellung "Akte 001 Kunstfehler" wurde versendet. </p><p>Geschätzte Versanddauer: 3 Tage</p><br><p>Ihr Spieleversand 24 Team</p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Do. Apr. 01 2022 09:45:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: true
            },
            {
                id: 103,
                from: {
                    email: 'angela@astro-horoskop-24.de',
                    name: 'Dein Horoskop Angela',
                    avatar: require('@src/assets/images/portrait/angela-horoskop.jpeg').default
                },
                to: [{
                    name: 'Francesca Rossi',
                    email: 'francesca.amore@pronto-posto.com'
                },
                ],
                subject: 'Dein Schicksal steht unter keinem guten Stern...',
                cc: [],
                bcc: [],
                message: '<h3>Huhu meine Liebe, hier kommt dein monatliches Liebeshoroskop ❤️ </h3><br><p>In der Liebe neigt der Stier zur sinnlichen Aufopferungsbereitschaft🙏🏼.</p><p>Jedoch nicht in jeder Paarung der Sternzeichen✨. Denn obwohl er so bereitwillig alles für eine harmonische Liebesbeziehung tun wird, lässt er sich von anderen Sternzeichen nicht den Sinn für das Schöne ausreden oder gar hintergehen 🙅‍♀️.</p><p>Doch er lebt auch in Angst, denn gerade in der Liebe können so viele unvorhergesehene Dinge passieren 😨, mit denen er aber aufgrund seiner Wesenszüge Probleme hat 😤. Er braucht die schöne heile Welt, in der er die Übersicht behalten kann 🥰.</p><br><p>Ich hoffe das hilft dir! Ich spüre keine guten Schwingungen bei dir aktuell!</p><br><h3>Bis bald meine Süße, deine Angela! ❤️🙏🏼❤️</h3>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Do. Apr. 02 2022 18:45:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: true
            },
            // novak spam mails
            {
                id: 104,
                from: {
                    email: 'mcr@geldschrank-vertriebs-gmbh.de',
                    name: 'MCR Geldschrank Vertriebs GmbH Berlin',
                    avatar: require('@src/assets/images/portrait/key.png').default
                },
                to: [{
                    name: 'Marc Novak',
                    email: 'marc.novak@pronto-posto.com'
                }],
                subject: 'Warnung vor der Kuchenblech Mafia',
                cc: [],
                bcc: [],
                message: '<h1><span style="color:red">Aufgebrochene Geldschränke säumen Deutschlands Straßen.</h1></span><p>Vertrauen Sie nicht der Konkurrenz. Deren Tresore sind weich wie Schuhkarton! <p></p><p>Nur unsere Produkte sind keine Sardinenbüchsen.</p><br><p>Jeden Tag liegt ein neuer Schrank am Boden, <b><span style="color:red">Ihrer könnte der nächste sein.</span></b></p><p>Handeln Sie jetzt und konktaktieren Sie unseren <b>Vertrieb!</b></p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Do. Apr. 10 2022 04:45:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: false
            },
            {
                id: 105,
                from: {
                    email: 'xxx@tough-love.de',
                    name: 'Tough Love Mobile Dating',
                    avatar: require('@src/assets/images/portrait/lips.jpeg').default
                },
                to: [{
                    name: 'Marc Novak',
                    email: 'marc.novak@pronto-posto.com'
                }],
                subject: 'Frauen aus Gretenburg wollen dich kennenlernen',
                cc: [],
                bcc: [],
                message: '<p>Marc, </p><p>worauf wartest du noch? Attraktive Frauen aus Gretenburg wollen dich kennenlernen! Bist du bereit für ein Abenteuer? Einen kleinen Seitensprung? Hol dir unsere App und erkunde deine wildesten Fantasien, du willst es doch auch!</p>',
                attachments: [],
                isStarred: true,
                labels: ['private'],
                time: 'Do. Mar. 27 2022 11:27:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: true
            },
            {
                id: 106,
                from: {
                    email: 'support@a12.paiipal.com',
                    name: 'Paypal SUPPORT',
                    avatar: require('@src/assets/images/portrait/blue-p-logo.jpeg').default
                },
                to: [{
                    name: 'Marc Novak',
                    email: 'marc.novak@pronto-posto.com'
                }],
                subject: 'BEDEUTEND NACHRIHT - BITTE GLECIH ZU LESEN DIES, MEINE GESCHAZTER FREUND!!!!!!!',
                cc: [],
                bcc: [],
                message: '<p>Ich bin mit diesem Medium, um Sie über die Transaktion zur Abgabe von $ 21500000 (Einundzwanzig Millionen fünfhunderttausend Euro) in meiner Bank in China, Sie als Empfänger zu informieren. Es wird zu 100% sicher, dass der Finanzvorstand des verstorbenen Kunden.</p><p>Bitte auf meine private E-Mail kontaktieren unter für Fragen und weitere Informationen Mit freundlichen Grüßen,</p><p>sang Chin</p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Do. Apr. 07 2022 11:10:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: true
            },






            // KS03 Traumschiff Rework: Rafaela Spam Mails

            {
                id: 107,
                from: {
                    email: 'offers@instant-crypto.pro',
                    name: 'Instant Crypto Offers',
                    avatar: require('@src/assets/images/portrait/crypto.png').default
                },
                to: [{
                    name: 'Rafaela S',
                    email: 'raf.silva@pronto-posto.com'
                }],
                subject: 'EXKLUSIV: Verdiene 5000% in 3 Tagen!',
                cc: [],
                bcc: [],
                message: '<p>Hey,</p><p>du wurdest für unser geheimes Investment-Programm ausgewählt. Verdiene jetzt hohe Renditen in Rekordzeit – starte mit nur 100€. Melde dich bei unserem Team, um dich anzumelden.</p><br><p>Gruß,<br>Instant Crypto Offers</p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Sat. Feb. 04 2023 12:12:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: false
            },

            {
                id: 108,
                from: {
                    email: 'funnybiz@wunderwelt.de',
                    name: 'Wunderwelt FunBiz',
                    avatar: require('@src/assets/images/portrait/funbiz.png').default
                },
                to: [{
                    name: 'Rafaela S',
                    email: 'raf.silva@pronto-posto.com'
                }],
                subject: 'Unglaublig aber Wahr!!! 😜',
                cc: [],
                bcc: [],
                message: '<p>Hey Rafaela,</p><p>Du wirst es nich glauben, aber wir haben gerade die super-duper Mega Aktion am Laufen! 😎<br>Alle die jetzt mitmachen bekommne gratis Einhorn-Sticker + ein Paket unschlagbarer Wunderbonbons.</p><p>Also warte nich zu lange sonst sind die weg, schwupp-di-wupp! 🦄🍬<br>Und psst… erzähl niemanden von meinem Geheimtip, sonst is alles vorbei!</p><br><p>Lachende Grüße,<br>Dein Wunderwelt FunBiz Team</p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Sat. Feb. 25 2023 09:51:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: false
            },

            {
                id: 109,
                from: {
                    email: 'winner@superlotto-global.com',
                    name: 'SuperLotto Global',
                    avatar: require('@src/assets/images/portrait/superlotto.png').default
                },
                to: [{
                    name: 'Rafaela S',
                    email: 'raf.silva@pronto-posto.com'
                }],
                subject: 'Sie haben gewonnen!',
                cc: [],
                bcc: [],
                message: '<p>Gratulation, Rafaela!</p><p>Sie wurden als Gewinnerin unseres SuperLotto-Gewinnspiels ausgewählt. Um Ihren Gewinn zu beanspruchen, kontaktieren Sie bitte unser Support-Team und halten Sie Ihre Angaben bereit. Der Anspruch verfällt in 48 Stunden.</p><br><p>Ihr SuperLotto Global Team</p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Wed. Mar. 01 2023 10:24:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: false
            },







            //ks04 flug
            {
                id: 110,
                from: {
                    email: 'omar@takatukaland-royal.org',
                    name: 'Prinz Omar',
                    avatar: require('@src/assets/images/portrait/prince.jpg').default
                },
                to: [{
                    name: 'Maximilian Lange',
                    email: 'm.lange@pronto-posto.com'
                }],
                subject: 'Prinz Omar braucht Ihre Hilfe!',
                cc: [],
                bcc: [],
                message: '<p>Lieber Freund,</p><p>Ich bin Prinz Omar vom fernen Königreich Takatukaland. Leider sitze ich auf Millionen Goldmünzen fest, die nur Sie retten können!</p><p>Helfen Sie mir, mein Vermögen auf Ihr Konto zu übertragen, und Sie erhalten lebenslang Einladungen zu königlichen Teepartys.</p><p><b>Bitte beeilen Sie sich, meine Tee-Vorräte sind begrenzt!</b></p><br><p>Euer verzweifelter Prinz Omar</p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Mi. Jul. 10 2024 18:24:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: false
            },
            {
                id: 111,
                from: {
                    email: 'info@wohlfuehlwunder.com',
                    name: 'Wohlfühlwunder-Team',
                    avatar: require('@src/assets/images/portrait/vitamins.jpg').default
                },
                to: [{
                    name: 'Maximilian Lange',
                    email: 'm.lange@pronto-posto.com'
                }],
                subject: 'Ärzte sind schockiert! Gemüse ist überflüssig!',
                cc: [],
                bcc: [],
                message: '<p>Lieber gesundheitsbewusster Freund,</p><p>Vergessen Sie Brokkoli, Spinat und Karotten! Unsere revolutionären Gummibärchen enthalten alle Vitamine, die Sie jemals brauchen könnten.</p><p>Bestellen Sie heute und wir senden Ihnen zusätzlich eine Packung Schokoladensalat gratis dazu!</p><br><p>Bleiben Sie gesund,<br>Ihr Wohlfühlwunder-Team</p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Do. Jul. 18 2024 20:11:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: false
            },
            {
                id: 112,
                from: {
                    email: 'service@cosmic-realestate.com',
                    name: 'Kosmisches Immobilien-Team',
                    avatar: require('@src/assets/images/portrait/moon.jpg').default
                },
                to: [{
                    name: 'Maximilian Lange',
                    email: 'm.lange@pronto-posto.com'
                }],
                subject: 'Ihr eigenes Grundstück auf dem Mond wartet!',
                cc: [],
                bcc: [],
                message: '<p>Sehr geehrte/r zukünftige Mondbesitzer/in,</p><p>Nutzen Sie jetzt Ihre einmalige Chance, offizieller Besitzer eines Grundstücks auf dem Mond zu werden.</p><p>Sichern Sie sich noch heute einen exklusiven Bauplatz mit unverbaubarem Blick auf die Erde. Limitierte Verfügbarkeit!</p><br><p>Ihr kosmisches Immobilien-Team</p>',
                attachments: [],
                isStarred: false,
                labels: ['personal'],
                time: 'Di. Jul. 23 2024 10:50:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: false
            },
            {
                id: 113,
                from: {
                    email: 'jobs@aqua-careers.org',
                    name: 'Aquatisches Karriere-Team',
                    avatar: require('@src/assets/images/portrait/dolphin.jpg').default
                },
                to: [{
                    name: 'Maximilian Lange',
                    email: 'm.lange@pronto-posto.com'
                }],
                subject: 'Wir suchen Delfin-Übersetzer – lukrative Gelegenheit!',
                cc: [],
                bcc: [],
                message: '<p>Sehr geehrte/r Meerliebhaber/in,</p><p>Sind Sie bereit für eine außergewöhnliche Karriere?</p><p>Wir suchen dringend Menschen, die Delfin-Sprache verstehen oder lernen möchten. Keine Vorerfahrung nötig, großzügige Vergütung garantiert.</p><p>Bewerben Sie sich heute noch!</p><br><p>Ihr aquatisches Karriere-Team</p>',
                attachments: [],
                isStarred: false,
                labels: ['company'],
                time: 'Mo. Jul. 29 2024 04:01:00 GMT+0000 (GMT)',
                replies: [],
                folder: 'inbox',
                isRead: false
            },


        ]
    }
    return data
}
